import { Circle } from "@eisox/design-system";

import { PlanningTypeKey, type PlanningType } from "~/features/planning";
import { m } from "~/paraglide/messages";

import { RoomDataEnum, roomDataIcon, type RoomDataMap } from "../helpers";

interface SetpointTempTooltipProps {
  currentTimeSlot: {
    temperature: number;
    type: PlanningType;
  };
  swOffset: number;
  roomData: RoomDataMap;
  showSwOffset: boolean;
}

export const SetpointTempTooltip: React.FC<SetpointTempTooltipProps> = ({
  currentTimeSlot,
  swOffset,
  roomData,
  showSwOffset,
}) => {
  const translations: Record<RoomDataEnum, string> = {
    [RoomDataEnum.autoConf]: m.auto_conf(),
    [RoomDataEnum.anticipation]: m.anticipation(),
    [RoomDataEnum.openWin]: m.open_window(),
    [RoomDataEnum.sun]: m.sunny_room(),
    [RoomDataEnum.autoPreConf]: m.unusual_absence_detection(),
  };

  return (
    <div className="[&>p]:font-light flex flex-col items-center gap-[20px] [&>p]:text-sm [&>p]:italic">
      <div className="flex w-full items-start gap-[20px]">
        <div className="flex flex-4 flex-col gap-[10px] whitespace-nowrap">
          <div className="flex flex-col items-center gap-[5px] [&_p:last-child]:text-primary-dark-gray">
            <p>{currentTimeSlot.temperature}°C</p>
            <PlanningTypeKey type={currentTimeSlot.type} />
          </div>
          {showSwOffset && (
            <div className="flex flex-col items-center gap-[5px] [&_p:last-child]:text-primary-dark-gray">
              <p>{`${swOffset > 0 ? "+" : ""} ${swOffset}`}°C</p>
              <p>{m.buttons_average()}</p>
            </div>
          )}
        </div>
        {Object.values(roomData).some(({ active, disabled }) => active && !disabled) && (
          <div className="flex flex-6 flex-col gap-[10px] whitespace-nowrap">
            {Object.entries(roomData).map(([key, { disabled, active }], index) =>
              active && !disabled ? (
                <div key={index} className="flex w-full items-center gap-[10px]">
                  <Circle.Root size={30} backgroundColor={"blue"} color={"white"}>
                    {roomDataIcon[key as keyof typeof roomDataIcon]}
                  </Circle.Root>
                  <p>{translations[key as keyof typeof translations]}</p>
                </div>
              ) : null,
            )}
          </div>
        )}
      </div>
    </div>
  );
};
